export const initWeatherWidget = () => {
  const weatherWidgetCitySelect = document.getElementById("weatherWidgetCitySelect");

  if (!weatherWidgetCitySelect) return;

  weatherWidgetCitySelect.addEventListener("change", updateWidget, {passive: true});

  function updateWidget() {
    const cityID = weatherWidgetCitySelect.value;

    _wcomWidget({
      id: "wcom-512c4d62aeaff631a430c305aac242af",
      location: cityID,
      format: "300x250",
      type: "summary",
    });
  }

  updateWidget();
};
